// export interface IUser {
//     username: string;
//     empresa: string;
//     obra: string;
//     roles: string;
//     email: string;
//     email_verified: boolean;
//     name: string;
// }
export default class User {
  username: string = "";
  empresa: string[] = [];
  obra: string[] = [];
  roles: string[] = [];
  email: string = "";
  email_verified: boolean = false;
  name: string = "";
  id_user: string = "";
  pk: string = "";
  sk: string = "";
  specific_rules: Object = {};
  tipo: string = "";
  constructor(user: any) {
    if (user.attributes || user.challengeParam) {
      this.preencheUserCognito(user);
      return;
    }
    if (user.PK) {
      this.preencheUserDynamo(user);
      return;
    }
    if (user.id_user || user.pk) {
      this.preencheUserDefault(user);
      return;
    }

    if (Object.keys(user).length) this.preencheUserFederado(user);
  }

  private preencheUserDynamo(user: any) {
    
    this.pk = user.PK;
    this.sk = user.SK;
    this.username = user.username;
    this.empresa = user.empresa;
    this.obra = user.obra;
    this.roles = user.roles;
    this.email = user.mail;
    this.email_verified = user.email_verified;
    this.name = user.displayName;
    this.specific_rules = user.specific_rules;
    this.tipo = "gali";
  }

  private preencheUserDefault(user: any) {
    
    this.pk = user.pk;
    this.sk = user.sk;
    this.username = user.username;
    this.empresa = this.testaJSON(user.empresa);
    this.obra = this.testaJSON(user.obra || []);
    this.roles = this.testaJSON(user.roles);
    this.email = user.email;
    this.email_verified = user.email_verified;
    this.name = user.name;
    this.specific_rules = user.specific_rules;
    this.tipo = user.tipo;
  }

  private preencheUserCognito(user: any) {
    
    if (user.challengeParam) {
      
      user.attributes = user.challengeParam.userAttributes;
    }
    this.pk = "";
    this.sk = "";

    this.username = user.username;
    this.email = user.attributes["email"];
    this.id_user = this.email;
    this.email_verified = user.attributes.email_verified;
    this.name = user.attributes.name;

    this.empresa = this.testaJSON(user.attributes["custom:empresa"]);
    this.obra = this.testaJSON(user.attributes["custom:obra"]);
    this.roles = this.testaJSON(user.attributes["custom:roles"]);
    this.specific_rules = this.testaJSON(
      user.attributes["custom:specific_rules"]
    );
    this.tipo = "cliente";
  }

  private preencheUserFederado(user: any) {
    
    this.pk = "";
    this.sk = "";
    this.username = user["cognito:username"];
    this.empresa = ["GALI"];
    this.obra = this.testaJSON(user["custom:obra"]);
    this.roles = this.testaJSON(user["custom:roles"]);
    this.email = user.identities ? user.identities[0]["userId"] : "";
    this.email_verified = true;
    this.name = user.name;
    this.id_user = user.sub;
    this.tipo = "gali";
  }

  public get todasPermissoes() {
    let permissõesDoUsuario = [...this.roles];
    permissõesDoUsuario.push(this.email);
    if (this.empresa?.length)
      permissõesDoUsuario = permissõesDoUsuario.concat(this.empresa);
    return permissõesDoUsuario;
  }

  temPermissao(permissoes: string[]) {
    return permissoes.some((permissao) => {
      return this.roles.includes(permissao);
    });
  }
  testaJSON(json: Object | string) {
    return typeof json == "string" ? JSON.parse(json) : json;
  }
}
